import * as React from "react";
import { HBox, VBox } from "framework/structural_components/hbox_vbox";
import { Button, Intent } from "framework/controls/button";
import { LoadingSpinner, LoadingError } from "framework/controls/loading";
import { NewCompetition } from "./newCompetitionView";
import { CompetitionView } from "./itemView";
import { cls_box_add } from "./view.css";
import { cls_item_box_1, cls_item_box_2, cls_item_box_3, cls_item_box_4, cls_item_box_5, cls_item_box_6, cls_item_box_7, cls_item_box_8, cls_item_box_9, cls_item_box_10, cls_item_box_11, } from "./itemView.css";
import { cls_label } from "framework/controls/label.css";
import { cls_colorMagenta60, cls_gap_form, cls_gap_half_rem, cls_gap_rem, cls_wrap } from "style/index.css";
import { cls_align_items_flex_end, cls_align_items_flex_start, cls_align_items_stretch, cls_justify_content_flex_end } from "framework/structural_components/hbox_vbox.css";
import { Filter } from "./filterView";
import { GetEditPermissions } from "../permissions";
import { EventState } from "public_app/events/entity";
import { useEventPlanning_Actions, useEventPlanning_Competitions_CompetitionIDsArrayState, useEventPlanning_Competitions_LoadingState, useEventPlanning_Event } from "../store";
var Buttons = function (_a) {
    var eventId = _a.eventId;
    var actions = useEventPlanning_Actions();
    var editPermissions = GetEditPermissions();
    return React.createElement(React.Fragment, null,
        editPermissions.Action || editPermissions.r04_addOrModifyCompetitions ? React.createElement(Button, { onClick: function () { return actions.competitions_createNewCompetition(eventId); } }, 'Přidat soutěž') : null,
        React.createElement(Button, { intent: Intent.NotAction, onClick: function () { return actions.competitions_setOrder('type'); } }, 'Seřadit podle typu'),
        React.createElement(Button, { intent: Intent.NotAction, onClick: function () { return actions.competitions_setOrder('endPresenceRegistration'); } }, 'Seřadit podle prezence'));
};
var Content = function (_a) {
    var _b;
    var eventId = _a.eventId;
    var all_competition_ids = useEventPlanning_Competitions_CompetitionIDsArrayState()[0];
    var event_store = useEventPlanning_Event()[0];
    var competitionErrors = (_b = event_store.errors['eventCompetitions[0].competitions']) === null || _b === void 0 ? void 0 : _b.errors;
    var toArray = function (err) {
        return err != null ? Array.isArray(err) ? err : [err] : null;
    };
    return React.createElement(VBox, { className: [cls_gap_form, cls_align_items_flex_start] },
        React.createElement(HBox, { className: [cls_gap_rem, cls_justify_content_flex_end, cls_box_add] },
            React.createElement(Buttons, { eventId: eventId })),
        React.createElement(NewCompetition, { eventId: eventId, fullValidation: event_store.entity.eventCompetitions[0].state !== EventState.Private, allCompetitionIds: all_competition_ids }),
        React.createElement(VBox, { className: cls_gap_half_rem },
            React.createElement(HBox, { className: [cls_gap_half_rem, cls_align_items_flex_end, cls_wrap] },
                React.createElement(VBox, { className: [cls_align_items_stretch, cls_label, cls_item_box_1] }, "Seri\u00E1l"),
                React.createElement(VBox, { className: [cls_align_items_stretch, cls_label, cls_item_box_7] }, "Pro"),
                React.createElement(VBox, { className: [cls_align_items_stretch, cls_label, cls_item_box_2] }, "Typ sout\u011B\u017Ee"),
                React.createElement(VBox, { className: [cls_align_items_stretch, cls_label, cls_item_box_3] }, "V\u011Bk"),
                React.createElement(VBox, { className: [cls_align_items_stretch, cls_label, cls_item_box_4] }, "Od t\u0159\u00EDdy"),
                React.createElement(VBox, { className: [cls_align_items_stretch, cls_label, cls_item_box_5] }, "Do t\u0159\u00EDdy"),
                React.createElement(VBox, { className: [cls_align_items_stretch, cls_label, cls_item_box_6] }, "Discipl\u00EDna"),
                React.createElement(VBox, { className: [cls_align_items_stretch, cls_label, cls_item_box_8] }),
                React.createElement(VBox, { className: [cls_align_items_stretch, cls_label, cls_item_box_9] }, "Prezence do"),
                React.createElement(VBox, { className: [cls_align_items_stretch, cls_label, cls_item_box_10] }, "Start/os."),
                React.createElement(VBox, { className: [cls_align_items_stretch, cls_label, cls_item_box_11] }),
                React.createElement(VBox, { className: [cls_align_items_stretch, cls_label, cls_item_box_11] })),
            React.createElement(Filter, null),
            all_competition_ids.map(function (id) { return React.createElement(CompetitionView, { key: id, compId: id, eventId: eventId }); })),
        competitionErrors && React.createElement(VBox, null, toArray(competitionErrors).map(function (err, i) { return React.createElement(VBox, { key: i, className: cls_colorMagenta60 }, err); })));
};
var LoadingSpinnerContainer = function () {
    var loading_state = useEventPlanning_Competitions_LoadingState()[0];
    return React.createElement(React.Fragment, null, loading_state.any_loadingTooLong && React.createElement(LoadingSpinner, null));
};
var LoadingErrorContainer = function () {
    var loading_state = useEventPlanning_Competitions_LoadingState()[0];
    var loading = loading_state.any_loading;
    var loadFailure = loading_state.any_loadFailure;
    var hasError = !loading && loadFailure;
    return React.createElement(React.Fragment, null, hasError && React.createElement(LoadingError, null));
};
var View = function (_a) {
    var eventId = _a.eventId;
    var loading_state = useEventPlanning_Competitions_LoadingState()[0];
    var showContent = !loading_state.any_loadFailure && loading_state.items_loaded;
    return React.createElement(React.Fragment, null,
        React.createElement(LoadingSpinnerContainer, null),
        React.createElement(LoadingErrorContainer, null),
        showContent && React.createElement(Content, { eventId: eventId }));
};
export { View as CompetitionsEdit };
